import type { Language } from '@/types/common'
import type { AboutPageContent, LearnPageContent } from '@/types/content'
import { apiClient } from './client'

export const contentApi = {
  getAboutPage(lang: Language) {
    return apiClient.get<AboutPageContent>('/api/content/about', { lang })
  },
  getLearnPage(lang: Language) {
    return apiClient.get<LearnPageContent>('/api/content/learn', { lang })
  },
}